export default __webpack_public_path__ + "static/media/home_banner_3.46af2e23.jpg";